// src/merch/Overview.jsx — merchmod.ca home: what MerchMod is, for the
// shops and fundraisers who'd run it as their own store. The designer
// itself is the demo (merchmod.ca/demo).

import React from "react";
import { href } from "./stores";

const CONTACT = "hello@merchmod.ca"; // TODO: set up this mailbox (or change it)

const FEATURES = [
  ["Live 3D designer", "Customers colour, letter and place art on a real 3D model of the product, front and back, on phone, tablet or desktop."],
  ["Selfie to player", "Upload a photo, the background and neck are cut away, and an illustrated face drops into the helmet. Every face is reviewed before printing."],
  ["Painted, recolourable templates", "Hand-illustrated players and gear that recolour to any team in one tap: jersey, stripes, helmet, gloves, face masks, hair."],
  ["Colouring sheets", "Print a sheet for every kid at the banquet. Scan the crayon drawings back in and they go to print like any other design."],
  ["True two-sided", "A separate design for the front and the back, not one image mirrored."],
  ["Print-ready, protected", "Orders come out as true-size print files with cut lines. Customers never get the file, so the art can't walk out the door."],
];

const STEPS = [
  ["You choose the products", "Ornaments, mini sticks, pucks and more, set up with your blanks, sizes and prices."],
  ["Your customers design", "On your own branded store, with team colours, names, numbers, logos and faces."],
  ["You print and deliver", "Every order lands in a review queue with a print-ready file. Approve it and print."],
];

export default function Overview({ demoHref = href("/demo") }) {
  return (
    <div className="mo">
      <header className="mo-top">
        <img className="mo-logo" src="/merch/MerchMod_Logo.svg" alt="MerchMod" />
        <nav>
          <a href="#how">How it works</a>
          <a href={`mailto:${CONTACT}`}>Contact</a>
          <a className="ma-btn primary" href={demoHref}>Try the demo</a>
        </nav>
      </header>

      <section className="mo-hero">
        <div className="mo-hero-copy">
          <p className="mo-kicker">You design it · We deliver it</p>
          <h1>Custom team merch, designed by your customers.</h1>
          <p className="mo-lead">
            MerchMod is a 3D product designer for team shops and fundraisers.
            Families design their own ornaments, mini sticks and keepsakes on
            your branded store. You get a print-ready file for every order.
          </p>
          <div className="mo-cta">
            <a className="ma-btn primary mo-big" href={demoHref}>Try the demo</a>
            <a className="ma-btn mo-big" href={`mailto:${CONTACT}?subject=MerchMod%20for%20my%20store`}>Get it for your store</a>
          </div>
        </div>
        <div className="mo-hero-shot">
          {/* a render straight from the 3D view (its background matches the panel) */}
          <img src="/merch/overview/hero-ornament.png" alt="A custom hockey player ornament designed in MerchMod" />
        </div>
      </section>

      <section className="mo-section">
        <h2>Everything a merch store needs, nothing it doesn't</h2>
        <div className="mo-grid">
          {FEATURES.map(([t, d]) => (
            <div key={t} className="mo-card">
              <h3>{t}</h3>
              <p>{d}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="mo-section" id="how">
        <h2>How it works</h2>
        <ol className="mo-steps">
          {STEPS.map(([t, d], i) => (
            <li key={t}>
              <b className="mo-num">{i + 1}</b>
              <div><h3>{t}</h3><p>{d}</p></div>
            </li>
          ))}
        </ol>
      </section>

      <section className="mo-section mo-band">
        <h2>Your store, your brand</h2>
        <p>
          Every store runs on its own address with its own logo and colours,
          and a small "Powered by MerchMod" in the footer. Built for team merch
          shops, fundraising companies, and decal and ornament makers.
        </p>
        <div className="mo-cta">
          <a className="ma-btn primary mo-big" href={demoHref}>Try the demo</a>
          <a className="ma-btn mo-big" href={`mailto:${CONTACT}?subject=MerchMod%20for%20my%20store`}>Talk to us</a>
        </div>
      </section>

      <footer className="ma-footer">
        <a href={href("/privacy")}>Privacy</a>
        <span>© MerchMod</span>
      </footer>
    </div>
  );
}
